import { Button } from '@pelckmans/business-components/components/button';
import { Dialog, ModalDialog } from '@pelckmans/business-components/components/dialog';
import { PropsWithChildren, ReactNode, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../contexts/ModalContext';
import MaterialModalHeader from './common/MaterialModalHeader';
import { Node } from '../_api/TableOfContentsApi';

type PreviewModalProps = PropsWithChildren<{
  id: string;
  name: string;
  node: Node;
  contentType: ReactNode;
  downloadUrl?: string;
  icon: ReactNode;
  downloadDisclaimer?: JSX.Element;
  tutorialId?: string;
}>;

export default function PreviewModal({
  id,
  name,
  node,
  contentType,
  downloadUrl,
  icon,
  children,
  downloadDisclaimer,
  tutorialId,
}: PreviewModalProps) {
  const { t } = useTranslation();

  const { closeModal } = useContext(ModalContext);

  const handleDownload = () => {
    window.open(downloadUrl, '_blank');
  };

  return (
    <ModalDialog
      id={id}
      closeViaEscape={!tutorialId}
      closeOnClickOutside={!tutorialId}
      closeTitle={t('ACTIONS.CLOSE')}
      onClose={() => closeModal(id)}
      className="material-dialog"
    >
      <MaterialModalHeader
        title={name}
        description={node.description}
        contentType={contentType}
        tutorialId={tutorialId}
      />
      <Dialog.Body>
        <div className="container--fluid">
          <div className="row row-gap-1">
            <div className="col-sm-2 preview-icon-wrapper">
              <div className="preview-icon">{icon}</div>
            </div>
            <div className="col-sm-10">{children}</div>
          </div>
        </div>
      </Dialog.Body>
      {(downloadUrl || downloadDisclaimer) && (
        <Dialog.Footer className={downloadDisclaimer ? 'justify-content-start' : undefined}>
          {downloadDisclaimer ?? (
            <Button onClick={handleDownload} variant="primary">
              <i className="bc-icon bc-icon-arrow-down bc-icon--left" />
              <span>{t('ACTIONS.DOWNLOAD')}</span>
            </Button>
          )}
        </Dialog.Footer>
      )}
    </ModalDialog>
  );
}
